import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import currentUserHasAccess from '../../../../util/widget-helper'
import { VOUCHER_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'

const moment = require('moment')

const isDateStillValid = (date) => moment().utc().diff(date) < 0

const VoucherWidget = ({ voucherList = [] }) => {
    if (!currentUserHasAccess(VOUCHER_WIDGET_CONTAINER)) {
        return null
    }

    if (!Array.isArray(voucherList) || voucherList.length < 1) {
        return null
    }

    return (
        <ContentBox title="Voucher Info">
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>still Available?</th>
                                <th>Voucher Code</th>
                                <th>Amount</th>
                                <th>Product</th>
                                <th>UsageCount</th>
                                <th>Valid Until</th>
                            </tr>
                        </thead>
                        <tbody>
                            {voucherList.map((voucher, index) => {
                                const { usageCount, validUntil, value, productLogicalId, code } = voucher
                                const isVoucherAvailable = usageCount === 0 && isDateStillValid(validUntil)
                                return <tr key={voucher.code + index}>
                                    <td>{isVoucherAvailable
                                        ? <div style={iconStyleGreen}><p>&#10004;</p></div>
                                        : <div style={iconStyleRed}>&#10539;</div>}</td>
                                    <td>{code}</td>
                                    <td>{value}</td>
                                    <td>{productLogicalId}</td>
                                    <td>{usageCount}</td>
                                    <td>{validUntil}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

VoucherWidget.propTypes = {
    voucherList: PropTypes.array.isRequired,
}

const iconStyleRed = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignContent: 'center',
    backgroundColor: 'red',
    color: 'white',
    borderRadius: '4px',
    width: '24px',
    height: '24px',
    fontSize: '14px',
    fontWeight: '900',
}
const iconStyleGreen = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignContent: 'center',
    backgroundColor: 'green',
    color: 'white',
    paddding: '4px',
    borderRadius: '4px',
    width: '24px',
    height: '24px',
    fontSize: '18px',
    fontWeight: '900',
}

export default VoucherWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/VoucherWidget.js